import { Box, styled, Typography } from '@mui/material'
import { navigate } from 'gatsby'
import * as React from 'react'
import { resultsState } from '../context/results-context'

import { convertFiltersToParamObject, parameterizeFilters } from '../utilities/sanity-filters'
import { candidateDataState } from '../context/candidate-data-context'
import FullScreenModal from './full-screen-modal'
import CandidateCard from './result-card/candidate-card'
import ResultsList from './result-list'

const CandidatesList = ({ title, onPageChange }: { title?: string; onPageChange?: Function }) => {
  const { candidates, totalCandidates, loading, nextPage, fetchNextPage } = candidateDataState()

  const {
    filters,
    activeCandidate,
    showResultModal,
    modalWasClickedInto,
    setModalWasClickedInto,
    setActiveCandidate
  } = resultsState()

  return (
    <Container>
      <ResultsList
        title={title}
        total={totalCandidates}
        results={candidates}
        loading={Boolean(loading)}
        nextPage={nextPage}
        fetchNextPage={fetchNextPage}
        onPageChange={onPageChange}
      >
        {data => {
          const candidate = data as Queries.SanityCandidate
          return (
            <CandidateCard
              data={candidate}
              onDetailClick={() => {
                setModalWasClickedInto(true)
                setActiveCandidate(candidate)
                navigate(`/candidate/${candidate.slug?.current}`)
              }}
            />
          )
        }}
      </ResultsList>
      <Typography variant="body2" color="textSecondary" pt={2}>
        *Candidate data may be incomplete and is updated weekly
      </Typography>
      <FullScreenModal
        contentPadding={true}
        open={Boolean(activeCandidate && showResultModal)}
        colorScheme="white"
        allowInnerScroll
        onClose={() => {
          if (modalWasClickedInto) {
            navigate(-1)
          } else {
            // this is happening if user landed on a specific action
            navigate(`/results/?${parameterizeFilters(convertFiltersToParamObject(filters))}`)
          }
        }}
      >
        {activeCandidate && <CandidateCard data={activeCandidate} detail={true} />}
      </FullScreenModal>
    </Container>
  )
}

const Container = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
`
export default CandidatesList
